import React from "react";
import MasterData from "view/settings/masterdata/MasterData";
const FinancialBGData = () => {
   
    const sections = [
        { label: "Status", value: "Status", items: [] },
        { label: "Issuing Bank", value: "IssuingBank", items: [] },
    ];
   

    return (
        <>
            <MasterData pageTitle="FinancialBG" sections={sections} />
        </>

    );
};

export default FinancialBGData;